import { theme } from 'antd';
import GoogleMapReact from 'google-map-react';
import React, { useEffect, useState } from 'react';
import { CONFIG } from '../constants';
import MarcadorRojo from '../static/MarcadorRojo.png';

const { useToken } = theme;

const defaultProps = {
  center: {
    lat: -25.2819,
    lng: -57.635
  },
  zoom: 13
};

const mapStyles = (small) => ({
  width: '100%',
  height: small ? '200px' : '400px',
  zIndex: 1
});

const markerStyle = (imageMarker) => ({
  marginLeft: '-16px',
  marginTop: '-32px',
  position: 'absolute',
  width: '32px',
  height: '32px',
  backgroundImage: `url(${imageMarker})`
});

const Marker = () => {
  return <div style={markerStyle(MarcadorRojo)} />;
};

const MapView = ({ coordenadas, zoom, marker, onClick, readOnly }) => {
  const { token } = useToken();
  const apiKey = CONFIG.GOOGLE_MAPS_KEY;
  const [latitud, setLatitud] = useState(coordenadas?.lat);
  const [longitud, setLongitud] = useState(coordenadas?.lng);
  const [showMarker, setShowMarker] = useState(marker);

  useEffect(() => {
    if (coordenadas) {
      setShowMarker(marker);
      setLatitud(coordenadas.lat);
      setLongitud(coordenadas.lng);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordenadas]);

  const handleClick = async (lat, lng) => {
    if (!readOnly) {
      setShowMarker(true);
      setLatitud(lat);
      setLongitud(lng);
      if (onClick) {
        onClick({ lat, lng });
      }
    }

    /* const direccion = await getDireccionByCoordenadas({ lat, lng }); // se obtiene direccion y se muestra en el input text
     */
  };

  return (
    <div
      style={{
        ...mapStyles(false),
        borderRadius: token.borderRadius,
        overflow: 'hidden'
      }}
    >
      <GoogleMapReact
        bootstrapURLKeys={{
          key: apiKey,
          libraries: ['places']
        }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        center={coordenadas}
        zoom={zoom}
        yesIWantToUseGoogleMapApiInternals
        onClick={({ lat, lng }) => handleClick(lat, lng)}
      >
        {showMarker && latitud && longitud && (
          <Marker lat={latitud} lng={longitud} />
        )}
      </GoogleMapReact>
    </div>
  );
};

export default MapView;
